import React, { useEffect, useState } from 'react';
import { Download, PlayCircle, AlertCircle, CheckCircle, Clock } from 'lucide-react';
import api from '../api';

export default function ExtractionHistory() {
  const [extractions, setExtractions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory();
    const interval = setInterval(fetchHistory, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await api.get('/admin/extractions');
      if (res.data && res.data.extractions) {
        setExtractions(res.data.extractions);
      }
    } catch (err) {
      console.warn('Erro ao buscar histórico de extrações:', err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (jobId) => {
    try {
      const res = await api.get(`/admin/extractions/${jobId}/download`, {
        responseType: 'blob'
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `leads_${jobId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      alert('Erro ao baixar excel da extração.');
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'running': return <PlayCircle size={16} className="status-running" style={{ color: 'var(--brand)' }} />;
      case 'completed': return <CheckCircle size={16} className="status-completed" style={{ color: '#10b981' }} />;
      case 'error': return <AlertCircle size={16} className="status-error" style={{ color: '#ef4444' }} />;
      case 'stopped': return <Clock size={16} className="status-stopped" style={{ color: '#f59e0b' }} />;
      default: return <Clock size={16} />;
    }
  };

  const formatPayload = (payload) => {
    if (!payload) return 'N/A';
    const cats = payload.categories ? payload.categories.join(', ') : '';
    const desc = [];
    if (cats) desc.push(`Cat: ${cats}`);
    if (payload.total_goal) desc.push(`Meta: ${payload.total_goal}`);
    if (payload.country) desc.push(payload.country);
    return desc.join(' | ') || 'N/A';
  };

  if (loading && extractions.length === 0) {
    return <div className="p-4" style={{ color: 'var(--text-muted)' }}>Carregando histórico...</div>;
  }

  if (extractions.length === 0) {
    return null;
  }

  return (
    <div className="client-glass-card mt-6" style={{ padding: '1.5rem' }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="client-card-title flex items-center gap-2" style={{ margin: 0, fontSize: '1.1rem' }}>
          <Clock size={18} /> Histórico de Extrações
        </h3>
      </div>
      
      <div style={{ overflowX: 'auto' }}>
        <table className="results-table" style={{ width: '100%', minWidth: '600px' }}>
          <thead>
            <tr>
              <th>Data</th>
              <th>Status</th>
              <th>Configuração</th>
              <th>Leads Extraídos</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {extractions.map((job) => (
              <tr key={job.id}>
                <td style={{ color: 'var(--text-secondary)' }}>
                  {new Date(job.started_at).toLocaleString('pt-BR')}
                </td>
                <td>
                  <div className="flex items-center gap-2">
                    {getStatusIcon(job.status)}
                    <span style={{ textTransform: 'capitalize', fontSize: '0.9rem' }}>{job.status}</span>
                  </div>
                  {job.error_message && (
                    <div style={{ color: '#ef4444', fontSize: '0.8rem', marginTop: '0.25rem' }}>
                      {job.error_message}
                    </div>
                  )}
                </td>
                <td style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                  {formatPayload(job.payload)}
                </td>
                <td style={{ fontWeight: 500 }}>
                  {job.results_count || 0}
                </td>
                <td>
                  <button 
                    onClick={() => handleDownload(job.id)}
                    className="client-btn client-btn--outline"
                    style={{ padding: '0.25rem 0.5rem', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
                    title="Baixar Excel desta Extração"
                  >
                    <Download size={14} /> Baixar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
